'use client';

import React from 'react';

interface ChipViewDesktopProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'selected';
  className?: string;
}

const ChipViewDesktop: React.FC<ChipViewDesktopProps> = ({
  label,
  isSelected = false,
  onClick,
  variant = 'default',
  className = ""
}) => {
  const getVariantStyles = () => {
    if (isSelected || variant === 'selected') {
      // Cuando está seleccionado:
      // - Borde de 50°
      // - borde color '3D1C1A'
      // - font color 'FEF5E6'
      // - color background '3D1C1A'
      return 'bg-[#3D1C1A] text-[#FEF5E6] border border-[#3D1C1A] rounded-[50px]';
    }
    // Cuando no está seleccionado:
    // - Borde de 50°
    // - borde color '3D1C1A' al 50%
    // - font color '3D1C1A'
    // - color background transparente
    return 'bg-transparent text-[#3D1C1A] border border-[#3D1C1A] border-opacity-50 rounded-[50px]';
  };

  return (
    <div data-component-id="src/components/ui/ChipViewDesktop.tsx:38:4" data-component-path="src/components/ui/ChipViewDesktop.tsx" data-component-line="38" data-component-file="ChipViewDesktop.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      onClick={onClick}
      className={`
        flex items-center justify-center
        px-7 md:px-9 py-[0.3rem]
        text-[18px] text-center
        cursor-pointer transition-all duration-150
        hover:opacity-90
        ${getVariantStyles()}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      style={{
        fontFamily: "'TT_Norms_Pro-Regular', 'TT Norms Pro', 'Inter', sans-serif",
        fontWeight: '400'
      }}
    >
      {label}
    </div>
  );
};

export default ChipViewDesktop;
